/**
 * useCategorySuggestion Hook (T082)
 * 
 * React hook for managing category suggestion state.
 * Handles loading, error, and suggestion data states.
 */

import { useState } from 'react'
import { categorySuggestionService, CategorySuggestion } from '../services/categorySuggestionService'

interface UseCategorySuggestionReturn {
  loading: boolean
  suggestion: CategorySuggestion | null
  error: string | null
  suggest: (conversationId: number) => Promise<void>
}

export function useCategorySuggestion(): UseCategorySuggestionReturn {
  const [loading, setLoading] = useState(false)
  const [suggestion, setSuggestion] = useState<CategorySuggestion | null>(null)
  const [error, setError] = useState<string | null>(null)

  const suggest = async (conversationId: number): Promise<void> => {
    setLoading(true)
    setError(null)

    try {
      const result = await categorySuggestionService.suggestCategory(conversationId)
      setSuggestion(result)
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred'
      setError(errorMessage)
      setSuggestion(null)
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    suggestion,
    error,
    suggest
  }
}
